import { collection, doc, getDoc, getDocs, limit, orderBy, query } from 'firebase/firestore';
import { auth, db } from '../firebase';

export function resolvePolicyCompanyId(userData = {}) {
  return (
    userData.companyId ||
    userData.checksCompanyId ||
    userData.companyID ||
    userData.shiftsCompanyId ||
    userData.company ||
    null
  );
}

export async function getCurrentUserCompanyId() {
  const user = auth.currentUser;
  if (!user) return null;

  try {
    const userDoc = await getDoc(doc(db, 'users', user.uid));
    if (!userDoc.exists()) return null;

    const userData = userDoc.data();
    const policyCompanyId = resolvePolicyCompanyId(userData);
    if (policyCompanyId) return policyCompanyId;

    const role = String(userData.role || userData.shiftsRole || '').toLowerCase();
    if (role.includes('super')) {
      const companiesSnap = await getDocs(query(collection(db, 'companies'), orderBy('__name__'), limit(1)));
      return companiesSnap.empty ? null : companiesSnap.docs[0].id;
    }

    return null;
  } catch (error) {
    console.error('Error fetching policy company ID:', error);
    return null;
  }
}

export async function getCurrentUserProfile() {
  const user = auth.currentUser;
  if (!user) return null;

  try {
    const userDoc = await getDoc(doc(db, 'users', user.uid));
    if (!userDoc.exists()) return null;
    const userData = userDoc.data();
    return {
      uid: user.uid,
      ...userData,
      policyCompanyId: resolvePolicyCompanyId(userData),
      role: userData.shiftsRole || userData.role || 'staff',
      assignedGroupIds: userData.shiftsAssignedGroupIds || userData.assignedGroupIds || [],
    };
  } catch (error) {
    console.error('Error fetching user profile:', error);
    return null;
  }
}

export async function getCurrentUserData() {
  return getCurrentUserProfile();
}
